var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero'),(_vm.loading)?_c('Teachers'):_vm._e(),(_vm.loading)?_c('TopCourses'):_vm._e(),(_vm.loading)?_c('Categories'):_vm._e(),_c('WhatWeDo'),_c('JoinAndBecome')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }